import { useState } from 'react';
import CTA from './CTA';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the data to a backend service
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <>
      <section className="contact" id="contact">
        <div className="contact-container">
          <div className="contact-header">
            <h2>Get In Touch</h2>
            <p>
              Have a question or ready to transform your space? We'd love to hear from you. 
              Reach out and let's start creating something beautiful together.
            </p>
          </div>

          <div className="contact-content">
            <div className="contact-info">
              <div className="info-card">
                <h3>📍 Visit Us</h3>
                <p>
                  Lune Livings Design Studio<br />
                  123 Design Avenue<br />
                  Creative City, CC 12345
                </p>
              </div>
              <div className="info-card">
                <h3>📞 Call Us</h3>
                <p>
                  Phone: +1 (555) 123-4567<br />
                  Mobile: +1 (555) 987-6543<br />
                  Available Monday - Saturday
                </p>
              </div>
              <div className="info-card">
                <h3>✉️ Email</h3>
                <p>
                  General: hello@lunelivings.com<br />
                  Projects: projects@lunelivings.com<br />
                  Support: support@lunelivings.com
                </p>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              {submitted && (
                <div className="form-success">
                  ✓ Thank you! We've received your message and will get back to you soon.
                </div>
              )}

              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your.email@example.com"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+1 (555) 000-0000"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="What is this about?"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us more about your project or inquiry..."
                  rows="6"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn-submit">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
      <CTA />
    </>
  );
}

export default Contact;
